import { useMutation } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { DemoRequestFormData } from "@/lib/validations/demo-request";

export const useDemoRequest = () => {
  return useMutation({
    mutationFn: async (data: DemoRequestFormData & { context?: string }) => {
      const { data: response, error } = await supabase.functions.invoke('send-demo-request', {
        body: data,
      });

      if (error) {
        throw new Error(error.message || "Erreur lors de l'envoi");
      }

      return response;
    },
    onSuccess: () => {
      toast({
        title: "Demande envoyée !",
        description: "Vous allez recevoir un email de confirmation.",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Erreur",
        description: error.message || "Une erreur s'est produite. Veuillez réessayer.",
        variant: "destructive",
      });
    },
  });
};
